import { IconStorage } from "@app/shared/icons/interfaces"; 

export const menuV1: IconStorage = {
  svgCode: () => ([
    "M3 12H21M3 6H21M3 18H21",
  ]),
};
